import {ImageList, ImageListItem} from "@mui/material";
import galleryImagesList from "../resources/images/gallery/galleryImagesLoader";
import Section from "./layouts/Section";
import {useTranslations} from "../store/LanguageProvider";

function srcset(image, size, rows = 1, cols = 1) {
    return {
        src: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format`,
        srcSet: `${image}?w=${size * cols}&h=${
            size * rows
        }&fit=crop&auto=format&dpr=2 2x`,
    };
}

const Gallery = () => {
    const {translations} = useTranslations();

    return <>
        <Section title={translations.gallery_title} id='gallery' white>
            <ImageList
                variant="quilted"
                cols={3}
                rowHeight={121}
            >
                {galleryImagesList.map((item) => (
                    <ImageListItem key={item.img} cols={item.cols || 1} rows={item.rows || 1}>
                        <img
                            {...srcset(item.img, 121, item.rows, item.cols)}
                            alt={item.title}
                            loading="lazy"
                        />
                    </ImageListItem>
                ))}
            </ImageList>
        </Section>
    </>
}

export default Gallery;